import { render, staticRenderFns } from "./CommentListItem.vue?vue&type=template&id=1a1c8939&scoped=true&"
import script from "./CommentListItem.vue?vue&type=script&lang=ts&"
export * from "./CommentListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CommentListItem.vue?vue&type=style&index=0&id=1a1c8939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c8939",
  null
  
)

/* custom blocks */
import block0 from "./CommentListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VSpacer})
